import { render, staticRenderFns } from "./AddQuizQuestion.vue?vue&type=template&id=32f1cae0&scoped=true&"
import script from "./AddQuizQuestion.vue?vue&type=script&lang=js&"
export * from "./AddQuizQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f1cae0",
  null
  
)

export default component.exports